<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="名称"></el-input>
				</el-form-item>
                <el-form-item>
					<el-input v-model="filters.keyword" placeholder="关键字"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="deviceTypes" highlight-current-row v-loading="listLoading" style="width: 100%;" border  :height="formHeight" size="mini">
			<!-- <el-table-column type="selection" width="55">
			</el-table-column> -->
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
			<el-table-column prop="name" label="名称"  sortable  width="200">
			</el-table-column>
			<el-table-column prop="keyword" label="关键字"  sortable>
			</el-table-column>
            <el-table-column prop="factorNames" label="监测因子"  min-width="250" sortable>
			</el-table-column>
			<el-table-column prop="moveFlag" label="是否移动噪声">
				<template slot-scope="scope">
					<span v-if="scope.row.moveFlag==1">是</span>
					<span v-else>否</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;"
			:page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--From界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formDeviceType" label-width="80px" :rules="formRules" ref="formDeviceType">
				<el-form-item label="名称" prop="name">
					<el-input v-model="formDeviceType.name" ></el-input>
				</el-form-item>
				<el-form-item label="关键字"  prop="keyword">
					<el-input v-model="formDeviceType.keyword" ></el-input>
				</el-form-item>
				<el-form-item label="监测因子" prop="factorIds"  id="facCheck">
					<div v-if='type=="修改"'>
						<el-checkbox-group  v-model="formDeviceType.factorIds" :disabled="true">
							<el-checkbox v-for="fac in FactorList" :key="fac.factorId" :label="fac.factorId">
								{{fac.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
					<div v-else>
						<el-checkbox-group  v-model="formDeviceType.factorIds">
							<el-checkbox v-for="fac in FactorList" :key="fac.factorId" :label="fac.factorId">
								{{fac.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</el-form-item>
				<el-form-item label="移动噪声?">
						<el-radio-group v-model="formDeviceType.moveFlag" :disabled="type=='修改'?true:false">
							<el-radio label='1'>是</el-radio>
							<el-radio label='0'>否</el-radio>
						</el-radio-group>
					</el-form-item>
				<el-form-item label="描述">
                    <el-input v-model="formDeviceType.remark" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import util from '../../common/js/util'
	import {getFactors, getDeviceTypeList,addDeviceType,updateDeviceType,deleteDeviceTypes } from '../../api/api';

    import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { myButton,TableUpdateButton},
		data() {
            var reg = new RegExp(/^[a-zA-Z\d]+$/);
            var validateKeyWord = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入关键字'));
                } else if(!reg.test(value)) {
                    callback(new Error('请输入字母或数字'));
                }else {
                    callback()
                }
            };
			return {
				filters: {
                    name: '',
                    keyword:''
				},
				deviceTypes: [],
				total: 0,
               	page:1,
				pageSize:10,
				listLoading: false,
				sels: [],//列表选中列

				formVisible: false,//修改界面是否显示
				FactorList:[],
                loading: false,
                formRules: {
					name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
					],
					icon: [
						{ required: true, message: '请选择图标', trigger: 'change' }
					],
					factorIds: [
						{ type: 'array', required: true, message: '请至少选择一个因子', trigger: 'change' }
					],
                    keyword: [
						{ required: true,validator: validateKeyWord, trigger: 'blur' }
					]
				},
				formHeight:0,
				//界面数据
				formDeviceType: {
					deviceTypeId: 0,
					name: '',
					keyword: '',
					icon:'',
					factorIds: [],
					remark: '',
					moveFlag:'0'
                },
                type:'新增'
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDeviceTypes();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDeviceTypes();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDeviceTypes();
			},
			//获取设备类型列表
			getDeviceTypes() {
				let para = {
                    page: this.page,
                    pageSize:this.pageSize,
                    name: this.filters.name,
					keyword:this.filters.keyword
				};
				this.listLoading = true;
				getDeviceTypeList(para).then((res) => {
					this.listLoading = false;
					this.total = res.data.data.total;
					this.deviceTypes = res.data.data.deviceTypes;
					for (let index = 0; index < 	this.deviceTypes.length; index++) {
						const element = 	this.deviceTypes[index];
						element.factorNames=element.factorNames.toString()
					}
				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
                this.formVisible = true;
				if( this.$refs.formDeviceType!=undefined){
               		this.$refs.formDeviceType.resetFields();
				}
				this.type='修改';
				row.moveFlag=row.moveFlag.toString();
				this.formDeviceType = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.formVisible = true;
				if( this.$refs.formDeviceType!=undefined){
               		this.$refs.formDeviceType.resetFields();
				}
				this.type='新增';
				this.formDeviceType={
					deviceTypeId: 0,
					name: '',
					keyword: '',
					icon:'',
					factorIds: [],
					remark: '',
					moveFlag:'0'
				}
			},
			//查询因子信息
			getFactors() {
				  this.listLoading = true;
					getFactors().then((res) => {
					this.FactorList = res.data.data;
					this.listLoading = false;
				});
			},
            //Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
            },
			//添加
			addSubmit: function () {
				this.$refs.formDeviceType.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;

							var para=new URLSearchParams();
							para.append('name', this.formDeviceType.name);
							para.append('remark', this.formDeviceType.remark);
							para.append('keyword', this.formDeviceType.keyword);
							para.append('moveFlag', this.formDeviceType.moveFlag);
							para.append('factorIds', this.formDeviceType.factorIds.toString());

                            addDeviceType(para).then((res) => {
								this.loading = false;
                              	let resData = res.data;
								  if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: "操作失败",
										type: 'error'
									})
								}
                                this.formVisible = false;                                
								this.getDeviceTypes();
                            });
						});
					}
				});
            },
            //修改
			editSubmit: function () {
				this.$refs.formDeviceType.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							var para=new URLSearchParams();
							para.append('name', this.formDeviceType.name);
							para.append('remark', this.formDeviceType.remark);
							para.append('keyword', this.formDeviceType.keyword);
							para.append('moveFlag', this.formDeviceType.moveFlag);
							para.append('factorIds', this.formDeviceType.factorIds.toString());
							para.append('deviceTypeId', this.formDeviceType.deviceTypeId);

                            updateDeviceType(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								  if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: "操作失败",
										type: 'error'
									})
								}
                                this.formVisible = false;                                
								this.getDeviceTypes();
                            });
						});
					}
				});
			},
            //取消按钮
            cancleSubmit:function(){
                this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getDeviceTypes();
			this.getFactors();			
		}
	}

</script>


// WEBPACK FOOTER //
// DeviceType.vue?0b29be2a